import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { oAuth } from '../providers/oAuth';
import { Pharmacies } from '../dataObjects/Pharmacies';
import { Reports, Report, ARFilter, RXFilter, DrugFilter, CustomerFilter, DoctorFilter, ReconcileGeneralReportFilter, ReconcileItemReportFilter } from '../dataObjects/ReportCenter';
import { ArFilterComponent } from '../ar-filter/ar-filter.component'
import { RxFilterComponent } from '../rx-filter/rx-filter.component';
import { DrugFilterComponent } from '../drug-filter/drug-filter.component';
import { CustomerFilterComponent } from '../customer-filter/customer-filter.component';
import { DoctorFilterComponent } from '../doctor-filter/doctor-filter.component';
import { BzqReconcileGeneralFilterComponent } from '../bzq-reconcile-general-filter/bzq-reconcile-general-filter.component';
import { BzqReconcileItemFilterComponent } from '../bzq-reconcile-item-filter/bzq-reconcile-item-filter.component';


import { GlobalVariable } from '../common/global';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-reportcenter',
  templateUrl: './reportcenter.component.html',
  styleUrls: ['./reportcenter.component.css']
})
export class ReportcenterComponent implements OnInit {

  reportCat: string[] = ['Accounts Receivable']
  displayedColumns: string[] = ['Category'];

  loading: boolean
  opened: boolean = true;
  panelOpenState: boolean
  openedFilter: boolean;
  PharmaciesSelectedValue: string
  Reportreturnimage: string;
  ReportOptionValue: number;
  selectedIndex: any;
  ReportsdisplayedColumns = ['colName'];

  pharms: Pharmacies[];
  reports: Reports[];
  Allreports: Reports[];
  selectedReport: Report;
  selectedCategory: Reports;

  ARFilter: ARFilter;
  RXFilter: RXFilter;
  DrugFilter: DrugFilter;
  CustomerFilter: CustomerFilter;
  DoctorFilter: DoctorFilter;
  ReconcileGeneralReportFilter: ReconcileGeneralReportFilter;
  ReconcileItemReportFilter: ReconcileItemReportFilter;

  constructor(private http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog, public Sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.PopPharmList();
    this.PopReports();

    this.ARFilter = {
      ARArRecordsRadioBox: 1, ARStatementDate: new Date, ARRadioSelectedValue: 2, ARDaysRangeValue: "All", ARPartitionBatchRadio: 1, ARSortingRadioBox: 1, AROptionsDateRadioBox: 1, ARReportTemplateValue: "Default", ARShowAddresscb: true, ARNoCurrentPostingcb: true,

      ARDaysRangeDD: [
        { value: 'All', viewValue: 'Include All' },
        { value: '>30', viewValue: 'Over 30' },
        { value: '>60', viewValue: 'Over 60' },
        { value: '>90', viewValue: 'Over 90' },
        { value: '>120', viewValue: 'Over 120' }
      ],

      ARReportOptionDD: [
        { value: '1', viewValue: 'PDF' },
        { value: '2', viewValue: 'JPEG' },
        { value: '3', viewValue: 'CSV' }
      ],

      ARReportTemplateDD: ['Manage Templates', 'Default']
    }

    this.RXFilter = {
      dtDynamicDDStartingDate: new Date,
      dtDynamicDDEndingDate: new Date,
      dtDynamicRefillDueStart: new Date,
      dtDynamicRefillDueEnd: new Date,
      dtDynamicPatientAddedStart: new Date,
      dtDynamicPatientAddedEnd: new Date,
      dtDynamicTransferredOutStart: new Date,
      dtDynamicTransferredOutEnd: new Date,
      cbDrugSchedule: 'Any',
      cb340B: 'ALL',
      cbBrandGeneric: 'Both',
      StateComboBox: 'ALL',
      cmbCompounds: 'ALL',
      cbCheckedout: 'ALL',
      cbStore: '00',
      cbRefillDue: false,
      cbPatientAdded: false,
      cbTransferredOut: false,
      cbTopDoctors: false,
      cbTopDrugs: false,
      cbAutochargeOnly: false,
      cbWelfareOnly: false,
      nudTopDoctors: '10',
      nudTopDrugs: '10',
      cbQueue: '',
      cbNursingHome: ''
    }

    this.DrugFilter = {
      cbSchedule: 'All',
      cbManufacturer: 'All',
      cbBrandGeneric: 'All',
      cbActiveInactive: 'All',
      cbCompound: 'All',
      txtPriceFormula: '',
      cb340B: 'All',
      cbUsage: false,
      cbPriceUpdate: false,
      cbNoActivitySince: false,
      cbInventoryOnly: false,
      cbLowStockOnly: false,
      dtUsage: new Date,
      dtPriceUpdate: new Date,
      dtLCSNoActivity: new Date,
      CustomField1: '',
      CustomField2: '',
      CustomField3: '',
      CustomField4: '',
    }

    this.CustomerFilter = {
      cbHeadOfHouseholdOnly: false,
      cbCustomersActivity: false,
      cbCustomersNoActivity: false,
      cbCustomersAdded: false,
      cbBirthdate: false,
      cbBorn: false,
      ckPrintCode: false,
      ckNotes: false,
      cbWithEmail: false,
      cbWithoutEmail: false,
      dtCustomerActivityStart: new Date,
      dtCustomerAddedStart: new Date,
      dtLCSCustomerNoActivity: new Date,
      dtBirthdateStart: new Date,
      dtBornStart: new Date,
      dtCustomerActivityEnd: new Date,
      dtCustomerAddedEnd: new Date,
      dtBirthdateEnd: new Date,
      dtBornEnd: new Date,
      txtPrintCode: '',
      cbGender: 'All',
      cbChargePrivileges: 'With and without charge privileges',
      txtPriceFormula: '',
      txtGroupNumber: '',
      CustomField1: '',
      CustomField2: '',
      CustomField3: '',
      CustomField4: ''
    }

    this.DoctorFilter = {
      cbActivity: false,
      cbNoActivity: false,
      cbDoctorsWithoutNPI: false,
      dtActivitySinceDynamic: new Date,
      dtNoActivitySinceDynamic: new Date,
      CustomField1: '',
      CustomField2: '',
      CustomField3: '',
      CustomField4: ''
    }

    this.ReconcileGeneralReportFilter = {
      cbShowDept: false,
      dtDateStart: new Date,
      dtDateEnd: new Date
    }

    this.ReconcileItemReportFilter = {
      DateStart: new Date,
      DateEnd: new Date,
      ExcludeScripts: false,
      PrintOnlyDepts: false,
      PrintOnlyClasses: false,
      PrintOnlyVendors: false,
      GroupByTicket: false
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 40000,
    });
  }

  PopPharmList(): void {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    this.http.get(GlobalVariable.BASE_API_URL + "/api/RxqOnePharmacies", options)
      .subscribe(
        (response) => {
          const resp = <[Pharmacies]>response
          this.pharms = resp;
          this.PharmaciesSelectedValue = "0";
        },
        (err) => {
          /* this function is executed when there's an ERROR */
          console.log("ERROR: " + err);
        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //console.log("COMPLETED");
        }
      );
  }

  PopReports(): void {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify("");

    this.http.post(GlobalVariable.BASE_API_URL + "/api/GetReports", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[Reports]>response
          this.reports = resp;
          this.Allreports = resp;

        },
        (err) => {
          /* this function is executed when there's an ERROR */
          console.log("ERROR: " + err);
        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //console.log("COMPLETED");
        }
      );
  }

  SelectCategory(cat: Reports) {
    this.selectedCategory = cat;
    //this.reports = this.Allreports.filter(el => el.Category === cat.Category);
  }

  ResetCategory() {
    this.selectedCategory = undefined;
    this.reports = this.Allreports;
  }

  SelectReport(rep: Report) {
    this.selectedReport = rep;
    this.Reportreturnimage = '';
  }

  filterDlg() {

    if (this.selectedCategory.Category == 'AR') {
      let dialogRef = this.dialog.open(ArFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose : true,
        data: { ARFilter: this.ARFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }

    if (this.selectedCategory.Category == 'Prescription') {
      let dialogRef = this.dialog.open(RxFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { RXFilter: this.RXFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
    if (this.selectedCategory.Category == 'Drug') {
      let dialogRef = this.dialog.open(DrugFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { DrugFilter: this.DrugFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
    if (this.selectedCategory.Category == 'Customer') {
      let dialogRef = this.dialog.open(CustomerFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { CustomerFilter: this.CustomerFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
    if (this.selectedCategory.Category == 'Doctor') {
      let dialogRef = this.dialog.open(DoctorFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { DoctorFilter: this.DoctorFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
    if (this.selectedCategory.Category == 'Reconcile General') {
      let dialogRef = this.dialog.open(BzqReconcileGeneralFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { ReconcileGeneralReportFilter: this.ReconcileGeneralReportFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
    if (this.selectedCategory.Category == 'Reconcile Item') {
      let dialogRef = this.dialog.open(BzqReconcileItemFilterComponent, {
        width: '97%',
        height: '97%',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: { ReconcileItemReportFilter: this.ReconcileItemReportFilter, pharm: this.PharmaciesSelectedValue, selectedReport: this.selectedReport, pharms: this.pharms }
      });
    }
  }

  indexChanged(index) {
    
    if (this.selectedIndex === null) {
      this.selectedIndex = index;
    }
    else if (this.selectedIndex === index) {
      this.selectedIndex = null;
    }
    else {
      this.selectedIndex = index;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reportcenter/reportcenter.component.ts